// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XiMN","inner":"Footer_inner__RqgVC","nextIcon":"Footer_nextIcon__3ZuIg","innerLeft":"Footer_innerLeft__r0KFK"};